import { useSelector } from 'react-redux'
import { formatPrice, getPercentageOfPrice, getTotalPriceOfProject } from '../../../../utility'
import props from '../../../../redux/props'
import Property from '../../PropertyList/Property'
import { Project } from '../../../../types/Project'
import _ from 'lodash'

type Props = {
  project: Project
  className?: string
}

const Workshop: React.FC<Props> = ({ project, className = '' }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const getTotalPrice = () => getTotalPriceOfProject(project)

  const additionalPriceIsSet =
    _.has(project, 'pricing.additional.price') && isFinite(project.pricing.additional.price) && project.pricing.additional.price > 0
  const discountPriceIsSet = _.has(project, 'pricing.discount') && isFinite(project.pricing.discount) && project.pricing.discount > 0

  return (
    <div className={className}>
      <Property
        property={{
          name: `${t.priceCalculator.attendee.label}`,
          valuePrefix: `${project.attendee.amount}${t.generic.multiply}${formatPrice(project.pricing.pricePerAttendee)}`,
          value: formatPrice(project.attendee.amount * project.pricing.pricePerAttendee),
        }}
      />
      {additionalPriceIsSet && (
        <>
          <Property
            className="mt-5"
            property={{
              name: t.priceCalculator.additionalCosts.label,
              value: formatPrice(project.pricing.additional.price),
            }}
          />
          {!!project.pricing.additional.description && <div className="text-sm text-gray-primary">{project.pricing.additional.description}</div>}
        </>
      )}
      {discountPriceIsSet && (
        <Property
          className="mt-5"
          property={{
            name: t.priceCalculator.discountAmount.label,
            value: formatPrice(project.pricing.discount),
          }}
        />
      )}
      <Property
        className="mt-5"
        property={{
          name: t.priceCalculator.total,
          value: formatPrice(getTotalPrice()),
        }}
      />
      <Property
        className="mt-5"
        property={{
          name: `${t.priceCalculator.downPayment} ${project.pricing.downPaymentPercentage}${t.generic.percent}`,
          value: formatPrice(getPercentageOfPrice(getTotalPrice(), project.pricing.downPaymentPercentage)),
        }}
      />
      <Property
        property={{
          name: `${t.priceCalculator.finalPayment} ${100 - project.pricing.downPaymentPercentage}${t.generic.percent}`,
          value: formatPrice(getPercentageOfPrice(getTotalPrice(), 100 - project.pricing.downPaymentPercentage)),
        }}
      />
    </div>
  )
}

export default Workshop
